import './card-location.scss';

export default () => {
};
